module.exports = __webpack_public_path__ + "99fda5c3bc8ff45ab0efd7881771ff42.jpg";